import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 lg:gap-16 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20modern%20reading%20space%20with%20floating%20manga%20book%20pages%20and%20warm%20ambient%20golden%20lighting%2C%20artistic%20illustration%20of%20a%20digital%20comics%20library%2C%20clean%20minimal%20aesthetic%20with%20coral%20and%20warm%20neutral%20tones%2C%20soft%20bokeh%20background%2C%20dreamy%20atmosphere&width=800&height=600&seq=about-manga-platform&orientation=landscape"
                alt="关于新新漫画 - 高清漫画在线阅读平台"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col gap-5">
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950">
              {aboutData.title}
            </h2>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutData.desc1}
            </p>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutData.desc2}
            </p>

            <div className="flex flex-wrap gap-3 pt-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium whitespace-nowrap">
                <i className="ri-check-line"></i> 正版授权
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs md:text-sm font-medium whitespace-nowrap">
                <i className="ri-check-line"></i> 每日更新
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs md:text-sm font-medium whitespace-nowrap">
                <i className="ri-check-line"></i> 高清画质
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium whitespace-nowrap">
                <i className="ri-check-line"></i> 安全直达
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}